import { useState, useEffect, FunctionComponent } from 'react';
import { Snackbar, Alert } from '@mui/material';

export interface TopAlertProps {
  message?: string;
  severity?: any;
  setMessage?: any
}

const TopAlert: FunctionComponent<TopAlertProps> = ({ message, severity = 'success', setMessage }) => {
  const [open, setOpen] = useState(false);

  // When message changes, show alert and start auto-close timer
  useEffect(() => {
    let timer: any;

    if (message) {
      setOpen(true);

      timer = setTimeout(() => {
        setOpen(false);
        // Delay clearing the message until after the Snackbar close animation
        setTimeout(() => setMessage(""), 300);
      }, 2000);
    }

    return () => {
      if (timer) clearTimeout(timer); // Always return a cleanup function (or undefined)
    };
  }, [message]);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={() => {
        setOpen(false);
        setTimeout(() => setMessage(""), 300);
      }}>
      <Alert severity={severity} variant="filled" onClose={() => {
          setOpen(false);
          setTimeout(() => setMessage(""), 300);
        }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
export default TopAlert;
